import { ReactNode } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useFeature } from "src/context/global";
import useStyles from "./Styles";

interface Option {
  label: string;
  value: string;
  featureId?: string;
}

interface DropdownProps {
  usersSelectValue: any;
  handleChangeSelect: (event: any) => void;
  options?: Option[];
  renderValue?: (value: any) => ReactNode;
  IconComponent?: any;
  renderOption?: (option: Option) => ReactNode;
  className?: string;
  sx?: any;
  displayEmpty?: boolean;
  id?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  usersSelectValue,
  handleChangeSelect,
  options,
  renderValue,
  IconComponent = KeyboardArrowDownIcon,
  renderOption,
  className,
  sx,
  displayEmpty,
  id,
}: DropdownProps) => {
  const { classes, cx } = useStyles();
  const { canUse } = useFeature();

  // Default options for time-range (backward compatibility)
  const defaultOptions: Option[] = [
    { label: "Today", value: "today", featureId: "daily_stats" },
    { label: "Yesterday", value: "yesterday", featureId: "yesterday_stats" },
    { label: "Last week", value: "week", featureId: "weekly_stats" },
  ];

  const currentOptions = options || defaultOptions;

  // Only include options allowed by the user's plan (if featureId is provided)
  const visibleOptions = currentOptions.filter(
    ({ featureId }) => !featureId || canUse(featureId),
  );

  return (
    <FormControl
      className={cx(classes.formControl, className)}
      size="small"
      sx={sx}
      id={id}
    >
      <Select
        value={usersSelectValue}
        onChange={handleChangeSelect}
        IconComponent={IconComponent}
        renderValue={renderValue}
        displayEmpty={displayEmpty}
        inputProps={{
          classes: {
            icon: classes.icon,
          },
        }}
        MenuProps={{
          className: classes.menu,
        }}
      >
        {visibleOptions.map((option) =>
          renderOption ? (
            <MenuItem key={option.value} value={option.value}>
              {renderOption(option)}
            </MenuItem>
          ) : (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
